import React, { useEffect, useState } from 'react';
import { AppLinkPreview, InternalPageRoot, PdfOrImgViewer } from "../../../index";
import { useTheme } from "../../../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullStr,
    getCurrUrlMainDomain,
    getCurrUrlParamValue,
    getJsonValue,
    getDefStr,
    isBoolTrue,
    isJsonValueTrue,
    trim
} from "../../../../common/fusion-ui/utils/ReactUtils";
import { formatDateValue, getAllocatedModuleName, printError, printLog, sendRequest } from "../../../utils/AppUtils";
import { useToast } from "../../../../common/fusion-ui/provider/ToastProvider";
import { Anchor } from "../../../../common/fusion-ui";
import { CssVariant, DefStrNA, Messages } from 'common/fusion-ui/config/FusionConfig';
import { GenRouteUrls, Keys, ModuleFieldsData, Modules, ReqUrls, ShareFeatureModules, ShowViewType } from "../../../config/AppConfig";
import { useConfig } from "../../../context/ConfigProvider";

const Doc_InternalPage = React.memo(({
    open,
    onHide,
    showAs = ShowViewType.PAGE,
}) => {
    const TAG = "Doc_InternalPage";

    const theme = useTheme();
    const { showToast, changeToastVariant } = useToast();
    const { updateConfig } = useConfig();

    const moduleName = Modules.Documents;
    const mf = ModuleFieldsData[moduleName];

    const Fields = {
        recordId: 'recordId',
        pageDataObject: 'pageDataObject',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFetched: 'isDataFetched',

        prevRecordId: 'prevRecordId',
        nextRecordId: 'nextRecordId',
    };

    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        const recordId = getCurrUrlParamValue('id');
        fetchPageData(recordId);
    }, []);

    // Added by vandit tewari on (4/11/24) - added all these lines here to give an downlad button for doc and also its preview all component for it is down in same file all these are variable to manage them.

    const docsFile = getPageField(mf.file); //used to get the url of file from the database to preview
    const hasdocsFile = !!docsFile; //here it checks wheteher link exists and store in variable
    const disabledTooltip = "No document available to download."; //This is tooltip message to be shown on hover of button in no document condition

    // Both of these realted to loading effect of iframe
    const [isLoading, setIsLoading] = useState(false); // State to track loading status of i frame
    // Handle iframe load event
    const handleIframeLoad = () => {
        setIsLoading(false);
    };

    // Added by Vandit Tewari (7/11/24) - added this use state and use effect to check wheather the link of file is broken on working on page load use effect check that preview available for file or not if not means file curpt in that case changes state which will effect rendering down the code
    const [isFileAvailable, setIsFileAvailable] = useState(true);
    const [isLoadingFile, setIsLoadingFile] = useState(true);

    useEffect(() => {
        if (docsFile) {
            const checkFileAvailability = async () => {
                try {
                    const response = await fetch(docsFile, { method: 'HEAD' });

                    if (response.ok) {
                        setIsFileAvailable(true);
                    } else {
                        setIsFileAvailable(false);
                    }
                } catch (error) {
                    setIsFileAvailable(false);
                } finally {
                    setIsLoadingFile(false);
                }
            };

            checkFileAvailability();
        }
    }, [docsFile]);

    return (<>
        <InternalPageRoot
            tag={TAG}
            moduleName={moduleName}
            title={`${getAllocatedModuleName(moduleName)} Details`}
            isDataFound={getField(Fields.isDataFound)}
            isDataLoading={getField(Fields.isDataLoading)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            internalPageUrl={GenRouteUrls.doc_internalPage}
            prevRecordId={getField(Fields.prevRecordId)}
            nextRecordId={getField(Fields.nextRecordId)}
            onPrev={() => fetchPageData(getField(Fields.prevRecordId), false)}
            onNext={() => fetchPageData(getField(Fields.nextRecordId), false)}
            showShare={ShareFeatureModules.some((item) => item.tag == TAG)}
            shareUrl={`${getCurrUrlMainDomain()}${GenRouteUrls.doc_internalPage}${getField(Fields.recordId)}`}
            open={open}
            onHide={onHide}
            showAs={showAs}>
            <div>
                {/* Document details */}
                <div className={`m-0 p-0 `}>
                    <table className={'w-100x'} style={{ color: theme.text }}>
                        <tbody>
                            {/*title*/}
                            <tr className='wmInternalPageTrBreak'>
                                <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.title.title}:</th>
                                <td className={'px-2 text-wrap text-break'}>{getPageField(mf.title, DefStrNA)}</td>
                            </tr>

                            {/* desc */}
                            <tr className='wmInternalPageTrBreak'>
                                <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.desc.title}:</th>
                                <td className={'px-2 text-wrap text-break'}>
                                    <div>{checkNullArr(getDescription())
                                        ? <ul className={'p-0 m-0 ls-none'}>
                                            {getDescription().map((item, index) => {
                                                return (checkNullStr(item)) &&
                                                    <li key={index + item}>
                                                        <span className={'select-none fw-semi-bold'}
                                                            style={{ color: theme.text50 }}>{index + 1}{'. '}</span>
                                                        <span>{item}</span>
                                                    </li>
                                            })}
                                        </ul>
                                        : <span>{getDefStr(getDescription() + '', DefStrNA)}</span>}
                                    </div>
                                </td>
                            </tr>

                            {/* Author */}
                            <tr className="mt-2x wmInternalPageTrBreak">
                                <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.author.title}:</th>
                                <td className={'px-2 text-wrap text-break'}>{getPageField(mf.author, DefStrNA)}</td>
                            </tr>

                            {/* Date */}
                            <tr className='wmInternalPageTrBreak'>
                                <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.date.title}:</th>
                                <td className={'px-2 text-wrap text-break'}>{formatDateValue(getPageField(mf.date), DefStrNA)}</td>
                            </tr>

                            {/* url */}
                            {/* This whole code is commented by Vandit Tewari on (4/11/24) this is old code insted on this added a new url code below with donload and preview feature*/}
                            {/* <tr>
                                <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.url.title}:</th>
                                <td className={'px-2 text-wrap'}>
                                    {checkNullStr(getPageField(mf.url)) ? (
                                        <Anchor
                                            href={getPageField(mf.url)}
                                            simple={true}
                                            target={'_blank'}>{getPageField(mf.url, DefStrNA)}</Anchor>
                                    ) : (
                                        <span>{DefStrNA}</span>
                                    )}
                                </td>
                            </tr> */}

                            {/* Added by vandit tewari on (4/11/24) - done this added new tr which has feature to preview and give download */}
                            <tr className='wmInternalPageTrBreak'>
                                <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>
                                    {mf.url.title}:
                                </th>
                                <td className={'px-2 text-wrap text-break'}>
                                    {getPageField(mf.url) ? (
                                        <Anchor href={getPageField(mf.url)} simple={true} target={'_blank'}>
                                            {getPageField(mf.url)}
                                        </Anchor>
                                    ) : (
                                        <span>{DefStrNA}</span>
                                    )}

                                </td>
                            </tr>
                            {/* Added by Vandit Tewari (5/11/24) - Done to print the name of column as file above preview conditionaly render it only if the file is availabel */}
                            {
                                hasdocsFile ? (
                                    <tr className='wmInternalPageTrBreak'>
                                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>
                                            {mf.file.title}:
                                        </th>
                                        {/*Added by Vandit Tewari (7/11/24) - added this bcz when file is non preview means format diffrent than also least provide link it only in one condition not give link if file not available */}
                                        <td className={'px-2 text-wrap text-break'}>
                                            {getPageField(mf.file) ? (
                                                isFileAvailable ? (
                                                    <Anchor href={getPageField(mf.file)} simple={true} target={'_blank'}>
                                                        {getPageField(mf.file)}
                                                    </Anchor>
                                                ) : (<span>{DefStrNA}</span>)
                                            ) : (
                                                <span>{DefStrNA}</span>
                                            )}

                                        </td>
                                    </tr>

                                ) : (<></>)
                            }
                        </tbody>
                    </table>
                    {/* Added by vandit tewari on (4/11/24) - This section is to give an download button. */}
                    {/* Updated by Vandit tewari on (7/11/24) - there with hasdocsFile give another check isFileAvailable bcz when file is curpt then also we not want user to download the file*/}
                    <button
                        className={hasdocsFile && isFileAvailable ? 'buttonPreviewTabOfDocuments' : 'disabeledButtonPreviewTabOfDocuments'}
                        onClick={() => hasdocsFile && isFileAvailable && (window.location.href = docsFile)} // Only navigate if file is available
                        disabled={!hasdocsFile || !isFileAvailable} // Disable if file is not available or broken
                        title={(!hasdocsFile || !isFileAvailable) ? disabledTooltip : "download"}  // Show tooltip if file is not available or broken
                    >
                        {<i className="fa fa-download" aria-hidden="true"></i>}
                    </button>

                    {/* Added by vandit tewari on (4/11/24) - This section is responsible to display whole preview tab in the page by checking an condition. */}
                    {/* Update by Vandit Tewari (7/11/24) - In this give an check at top it will give preview of file only for these 3 format otherwise there is no preview for other formats */}
                    {hasdocsFile && docsFile && (
                        /\.(pptx|pdf|docx)$/i.test(docsFile) ? (
                            isLoadingFile ? (
                                <p>Loading...</p> // Show loading message while checking file
                            ) : isFileAvailable ? (
                                <div
                                    className="iframe-container"
                                    style={{ position: 'relative' }}
                                >
                                    <iframe
                                        className="previewTabOfDocuments"
                                        src={`https://drive.google.com/viewerng/viewer?embedded=true&url=${encodeURIComponent(docsFile)}`}
                                        title="Document Preview"
                                        height={500}
                                        style={{ display: !isLoading ? 'block' : 'none' }}
                                    ></iframe>
                                </div>
                            ) : (
                                <></> // Error message if file is unavailable
                            )
                        ) : (
                            <p>No preview available</p> // Unsupported file type message
                        )
                    )}
                </div>

                {/* Document viewer */}
                {/* <div className={'mt-3 mb-3 bg-infox'}>
                    <AppLinkPreview url={getPageField(mf.url)} />

                    <PdfOrImgViewer
                        src={getDefStr(getPageField(mf.file), getPageField(mf.rFile))}
                        fileExt={getDefStr(getPageField(mf.docFileExt), getPageField(mf.rDocFileExt))}
                    />
                </div> */}
            </div>
        </InternalPageRoot>
    </>)

    /**
     * @example
     * const contentsString = "Contents: (1) From MDG to SDG (2) Meningococcal disease & its epidemiological pattern (3) Indian burden of IMD (4) Meningococcal Conjugate Vaccines (5) Efficacy, Immunogenicity & Effectiveness of MCV (6) Recommendations & global MCV uptake.";
     * const resultList = getDescription(contentsString);
     * console.log(resultList);
     * //output:
     * [
     *   'From MDG to SDG',
     *   'Meningococcal disease & its epidemiological pattern',
     *   'Indian burden of IMD',
     *   'Meningococcal Conjugate Vaccines',
     *   'Efficacy',
     *   'Immunogenicity & Effectiveness of MCV',
     *   'Recommendations & global MCV uptake.'
     * ]
     */
    function getDescription() {
        const desc = getPageField(mf.desc) + '';
        if (checkNullStr(desc)) {
            // Remove "Contents:" from the beginning of the string (case-insensitive)
            const trimmedString = desc.replace(/^contents:/i, '').trim();
            // Split the remaining string by commas and/or parentheses to get individual items
            const items = trimmedString.split(/[,(]/);
            // Trim each item and remove any empty strings
            return items.map(item => trim((item + '').trim().replace(/^\d+\)/, '').replace(/\)$/, ''))).filter(item => checkNullStr(item));
        } else {
            return ''
        }
    }

    //======================Request Functions start=====================
    async function fetchPageData(recordId, checkBefore = true) {
        const fun = 'fetchPageData:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isDataFetched))) {
            log(fun, 'recordId:', recordId);
            updateField(Fields.isDataFetched, true);
            updateField(Fields.recordId, recordId);
            if (checkNullStr(recordId)) {
                updateField(Fields.pageDataObject, {});
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, true);
                updateField(Fields.dataLoadingMsg, "");
                updateField(Fields.nextRecordId, null);
                updateField(Fields.prevRecordId, null);

                //send-request
                const REQUEST_OPTIONS = {
                    recordId: recordId,
                    getAdjacentRecordIds: true,
                };
                try {
                    sendRequest({
                        reqUrl: ReqUrls.doc__addEditPage_fetch_editFormData,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const fetchedPageData = getJsonValue(fetchedData, 'data', {});
                            const success = isJsonValueTrue(fetchedData, 'success');
                            const message = getJsonValue(fetchedData, 'message');
                            const nextRecordId = getJsonValue(fetchedPageData, 'nextRecordId');
                            const prevRecordId = getJsonValue(fetchedPageData, 'prevRecordId');

                            if (success) {
                                // toast(message, CssVariant.success)
                                updateField(Fields.pageDataObject, fetchedPageData);
                                updateField(Fields.nextRecordId, nextRecordId);
                                updateField(Fields.prevRecordId, prevRecordId);
                                updateField(Fields.isDataFound, success);
                                updateField(Fields.isDataLoading, false);

                                updateConfig(Keys.sharePanel_recordTitle, getJsonValue(fetchedPageData, mf.title.column));
                                updateConfig(Keys.sharePanel_recordDescription, getJsonValue(fetchedPageData, mf.desc.column));
                            } else {
                                toast(message, CssVariant.danger)
                                updateField(Fields.dataLoadingMsg, message);
                                updateField(Fields.isDataLoading, false);
                                updateField(Fields.isDataFound, false);
                            }
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            toast(Messages.fetchError, CssVariant.danger)
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } catch (error) {
                    toast(Messages.fetchError, CssVariant.danger)
                    logErr(fun, error);
                    updateField(Fields.dataLoadingMsg, Messages.fetchError);
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            } else {
                toast('Record-id not found!', CssVariant.danger);
                updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, false);
            }
        }
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================

    function getPageField(colField, defValue) {
        return getJsonValue(getField(Fields.pageDataObject), colField.column, defValue);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({ ...prevState, [field]: value }));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default Doc_InternalPage;
